import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

import Label from '../../label';

import { Inputs } from './components';
import { findComparisonOperator, getCustomFilterMessage } from './utils';

import { Container, CloseButton, UserMadeFilter } from './styles';

const CustomFilters = () => {
    const dispatch = useDispatch();
    const userMadeFilters = useSelector((state) => state.playersAndTeams.filter.values.customFilters);
    const reportCategory = useSelector((state) => state.playersAndTeams.report.reportCategory);
    const reportName = useSelector((state) => state.playersAndTeams.report.applied.reportName);

    const deleteFilter = (indexToRemove) => {
        const remainingFilters = userMadeFilters.filter((_, index) => index !== indexToRemove);
        dispatch(filterActionCreators.setCustomFilters(remainingFilters));
    };

    // We only want the submitted filters, not the current which the user can modify
    const UserFilters = userMadeFilters.map((filter, index) => {
        const operatorSign = findComparisonOperator(filter.operator);
        return (
            <UserMadeFilter key={`${filter.measure}${operatorSign}`}>
                <span>
                    <FormattedMessage {...getCustomFilterMessage(reportCategory, reportName, filter.measure)} />
                </span>
                <span>{operatorSign}</span>
                <span>{filter.value}</span>
                <CloseButton onClick={() => deleteFilter(index)}>&#10761;</CloseButton>
            </UserMadeFilter>
        );
    });

    return (
        <Container>
            <Label>
                <FormattedMessage {...commonMessages.filters.custom} />
            </Label>
            <Inputs />
            {UserFilters}
        </Container>
    );
};

export default React.memo(CustomFilters);
